import {Skeleton} from '@mui/material';
import {IVendorListItemEntity} from 'pwm-shared/src/types';
import React, {useEffect} from 'react';
import {GetVendorProjectsResponse, useVendorApi} from 'src/PWM/pages/vendors/vendor.api';
import VendorAssignmentTable from 'src/PWM/pages/vendors/components/VendorAssignmentTable';

const VendorProjectAssignments: React.FC<IVendorProjectAssignmentsProps> = ({vendorId}) => {
  const [projects, setProjects] = React.useState<GetVendorProjectsResponse[]>([]);
  const [hasRun, setHasRun] = React.useState<boolean>(false);

  const vendorApi = useVendorApi();

  useEffect(() => {
    getVendorInfo();
  }, [vendorId]);

  const getVendorInfo = async () => {
    if(!vendorApi || !vendorId) return;
    const {data} = await vendorApi.getVendorAssignments(vendorId);
    setProjects(data.data || []);
    setHasRun(true);
  }
  // display loading indicator
  if(!hasRun) {
    return <Skeleton variant="rectangular" width="100%" height="100%" animation="wave" sx={{p: 2}} />;
  }
  return (
    <VendorAssignmentTable projects={projects as unknown as IVendorListItemEntity[]} />
  );
};

export default VendorProjectAssignments;

interface IVendorProjectAssignmentsProps {
  children?: React.ReactNode;
  vendorId: number;
}

